export default __webpack_public_path__ + "static/about-story-image-mobile-357494a6c5f910dff85bfa22623e3cb2.webp";